import React, { PropTypes, Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import {
  Divider,
  FontIcon,
  MenuItem,
  Paper,
  RaisedButton,
} from 'material-ui';
import injectStyleSheet from 'react-jss';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import MasterTemplateIcon from 'material-ui/svg-icons/action/extension';
import R from 'ramda';
import DropdownMenu from '../../tc-ui/flatDropDownMenu';
import WallWrapper from '../../wall/wrapper';

const styles = {
  container: {
    marginBottom: '56px',
    backgroundColor: 'white',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'stretch',
  },
  leftSide: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'white',
    fontSize: '18px',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '250px',
    overflow: 'hidden',
  },
  btnDiv: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'white',
    fontSize: '18px',
    height: '48px',
    minHeight: '48px',
    textAlign: 'center',
  },
};

class TemplateListContainer extends Component {
  renderMenuItem = R.curry((icon, label, route) => {
    const isActive = window.location.href.indexOf(route) > -1;
    return (
      <div
        className={`contracting-left-nav-widget-link ${isActive ? 'is-active' : ''}`}
        style={{ color: isActive ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center' }}
        onClick={() => this.props.push(route)}
      >
        {
          R.is(String, icon) ? (
            <FontIcon
              className={icon}
              color={isActive ? '#00bcd4' : 'white'}
              style={{ width: '36px' }}
            />
          ) : cloneElement(icon, { color: isActive ? '#00bcd4' : 'white', style: { width: '36px' } })
        }
        <span style={{ lineHeight: '24px', width: '80%' }}>
          {label}
        </span>
      </div>
    );
  });
  render() {
    const { children, classes, push, templates = [] } = this.props;
    const queuedUpdatesCount = templates.filter(obj => obj.stagedUpdates && obj.stagedUpdates.length).length;
    return (
      <Paper className={classes.container}>
        <div className={classes.leftSide}>
          <div className={classes.btnDiv}>
            <DropdownMenu
              button={<RaisedButton
                primary
                label="Create Template"
                style={{ marginTop: '6px', minWidth: '250px' }}
                icon={<FontIcon className="tc-icon-add" />}
              />}
            >
              <MenuItem
                primaryText="Rate Template"
                onTouchTap={() => push('/contracting/create-template-draft')}
              />
              <Divider/>
              <MenuItem
                primaryText="Template Group"
                onTouchTap={() => push('/contracting/create-template-group')}
              />
              <Divider/>
              <WallWrapper amazonOrange lockIcon skipClick>
                <MenuItem
                  primaryText="Corporate Policies & Notes"
                  onTouchTap={() => push('/contracting/create-master-template')}
                />
              </WallWrapper>
            </DropdownMenu>
          </div>
          <Paper
            className={`contracting-left-nav-widget`}
            style={{ backgroundColor: '#383E4B', flex: '1' }}
            zDepth={2}
          >
            {this.renderMenuItem(
              <TemplateIcon/>,
              'Rate Templates',
              '/contracting/template-list',
            )}
            <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', margin: '16px 0' }} />
            {/*<div className="flex-tc-sb" style={{ padding: '0 16px' }}>*/}
              {/*<div style={{ color: 'white', fontSize: '14px' }}>Secondary Templates</div>*/}
            {/*</div>*/}
            <WallWrapper amazonOrange slug="upgrade-rates-corp" skipClick>
              {this.renderMenuItem(
                <MasterTemplateIcon/>,
                'Corporate Policies & Notes',
                '/contracting/master-template-list?type=policyNotes',
              )}
            </WallWrapper>
            {
              Boolean(queuedUpdatesCount) && (
                <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', margin: '16px 0' }} />
              )
            }
            {
              Boolean(queuedUpdatesCount) && this.renderMenuItem(
                <TemplateIcon/>,
                'Updates Queue',
                '/contracting/supplier-updates-queue',
              )
            }
          </Paper>
        </div>
        <div style={{ width: '80%' }}>{children}</div>
      </Paper>
    );
  }
}

TemplateListContainer.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  push: PropTypes.func,
  classes: PropTypes.object,
  openCreateDraftDialog: PropTypes.func,
  templates: PropTypes.array,
};

const mapStateToProps = ({ contracting }) => ({
  templates: contracting.templateList.toJS().templates,
});

const mapDispatchToProps = {
  push: pushAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStyleSheet(styles)(TemplateListContainer));



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/template-list-container.jsx